module.exports = __webpack_public_path__ + "img/05.d8715063.png";